<template>
  <div class="mainContent">
    <main-title :arrowClick="true">
      <template v-slot:rightBtn></template>
    </main-title>

    <component :is="navComponent"></component>
    <!-- <nav-bar /> -->
    <lengend-bar />

    <!-- <wz-bar /> -->
    <component :is="leftComponent"></component>
    <component
      :is="rightComponent !== 'video' ? rightComponent : 'videos'"
    ></component>
    <hright-side></hright-side>
  </div>
</template>

<script>
const hrightSide = () => import("@/components/hrightSide");
// top nav
const navDrawer = () => import("./cyzl/navBar");
const navDrawer0 = () => import("./navBar"); //产业园区
// const cyldNavBar = () => import("./cyld/navBar"); //产业亮点 已删除
// const zzjdNavDrawer = () => import('./zzjdDrawer/navBar'); // 种植基地
// const zzglNavDrawer = () => import("./zzglDrawer/navBar"); // 种植管理
const jsxmNavDrawer = () => import("./jsxmDrawer/navBar"); // 建设项目
const ssztNavDrawer = () => import("./ssztDrawer/navBar"); // 实施主体
const zhwlNavDrawer = () => import("./zhwlDrawer_N/navBar"); // 智慧物联
const lndnNavDrawer = () => import("./lndnDrawer/navBar"); // 智慧物联
const schjDrawer = () => import("../schj/schj"); //市场营销
const lengendBar = () => import("./legendBar");
// // 背景
// const wzBar = () => import("./wzBar");
// 右则
const rightDrawer0 = () => import("./homeDrawer/rightBar"); //产业园区
const rightDrawer = () => import("./cyzl/rightBar"); //产业总览

const cyldDrawer = () => import("./cyld/rightBarNew"); //产业亮点
const zzjdDrawer = () => import("./zzjdDrawer/rightBar"); //种植基地
const ssztDrawer0 = () => import("./ssztDrawer/rightBar"); //实施主体
const zhwlDrawer = () => import("./zhwlDrawer_N/rightBar"); //智慧物联
const jsxmDrawer = () => import("./jsxmDrawer/rightBar"); //建设项目
const scyxDrawer = () => import("./scyxDrawer/index"); //市场营销左侧
const scyxRightDrawer = () => import("./scyxDrawer/rightBar"); //市场营销右侧
const sdcgLeftbar = () => import("./scyxDrawer/sdcgLeftbar"); //市场营销 =>外地采购 左侧
const sdcgRightbar = () => import("./scyxDrawer/sdcgRightbar"); //市场营销 =>外地采购 右侧
const zzyDrawer = () => import("../zzy/drawer/rightBar"); //种植业
const zzglRgihtDrawer = () => import("./zzglDrawer/rightBar"); //种植管理
// import mapNavBar from "./mapNavBar"; // 右下标注 old
// 左则
const leftDrawer0 = () => import("./homeDrawer/leftBar"); //产业园区
const leftDrawer = () => import("./cyzl/leftBar"); //产业总览
const cyldlDrawer = () => import("./cyld/leftBar"); //产业亮点
const zzglLeftDrawer = () => import("./zzglDrawer/leftBar"); //种植管理

const warnDrawer = () => import("./homeDrawer/drawer/warnDrawer");
const weatherDrawer = () => import("./homeDrawer/drawer/weatherDrawer");
const newDrawer = () => import("./homeDrawer/drawer/newDrawer");
const ghmjDrawer = () => import("./mapDrawer/ghmj");
const njfbDrawer = () => import("./mapDrawer/njfb"); //农机分布详情
const yqztzDrawer = () => import("./mapDrawer/yqztz");
const ssztDrawer = () => import("./mapDrawer/sszt");
const lndnDrawer = () => import("./lndnDrawer/index");
const yzjdDrawer = () => import("./mapDrawer/yzjd");
const zypDrawer = () => import("./mapDrawer/zyp"); //资源圃详情
const cqDrawer = () => import("./mapDrawer/cq"); //虫情详情
const sclsDrawer = () => import("./mapDrawer/scls");
const env = () => import("./zhwlDrawer/qxz/index");
const nq = () => import("./zhwlDrawer/video/index");
const soil = () => import("./zhwlDrawer/sq/index");
const weather = () => import("./zhwlDrawer/qxz/index");
const videos = () => import("./zhwlDrawer/video/index");
const pest = () => import("./zhwlDrawer/cqcb/index"); //虫情测报
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters([
      "drawerComponent",
      "navComponent",
      "leftComponent",
      "rightComponent",
      "bottomList",
      "roles"
    ])
  },
  data() {
    return {
      name: "全屏",
      fullScreen: false
    };
  },
  components: {
    // homeDrawer,
    hrightSide,
    navDrawer,
    navDrawer0,
    zhwlNavDrawer,
    lndnNavDrawer,
    ssztNavDrawer,
    lengendBar,
    // wzBar,
    rightDrawer,
    rightDrawer0,
    leftDrawer,
    leftDrawer0,
    warnDrawer,
    weatherDrawer,
    newDrawer,
    ghmjDrawer,
    njfbDrawer,
    yqztzDrawer,
    ssztDrawer,
    lndnDrawer,
    yzjdDrawer,
    zypDrawer,
    cqDrawer,
    sclsDrawer,
    zzjdDrawer,
    // zzjdNavDrawer,
    jsxmDrawer,
    jsxmNavDrawer,
    zhwlDrawer,
    scyxDrawer,
    scyxRightDrawer,
    sdcgLeftbar,
    sdcgRightbar,
    ssztDrawer0,
    zzyDrawer,
    // zzglNavDrawer,
    zzglRgihtDrawer,
    zzglLeftDrawer,
    // mapNavBar,
    env,
    nq,
    soil,
    weather,
    videos,
    schjDrawer,
    pest,
    cyldDrawer,
    cyldlDrawer
  },
  mounted() {
    let that = this;
    window.onresize = function() {
      setTimeout(() => {
        if (!that.fullscreenElement()) {
          that.fullScreen = false;
          that.name = "全屏";
        }
      });
    };
  },
  methods: {
    fullscreenElement() {
      var fullscreenEle =
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement;
      return fullscreenEle;
    },

    qplick() {
      var docElm = document.documentElement;
      if (!this.fullScreen) {
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen();
          this.name = "退出全屏";
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen();
          this.name = "退出全屏";
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen();
          this.name = "退出全屏";
        }
        this.fullScreen = true;
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          this.name = "全屏";
        }
        //FireFox
        else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
          this.name = "全屏";
        }
        //Chrome等
        else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
          this.name = "全屏";
        }
        //IE11
        else if (document.msExitFullscreen) {
          document.msExitFullscreen();
          this.name = "全屏";
        }
        this.fullScreen = false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
@media (max-width 1280px)
  .btn
    height 20px !important
    bottom -1px !important
    line-height 20px !important
    font-size 0.08rem !important
    width 70px !important
  .eventBtn
    right 5px !important
  .videoBtn
    right 80px !important
  .qpBtn
    right 155px !important
  .yjBtn
    right 230px !important
.mainContent
  height 100%
  position relative
  overflow hidden

.btn
  position absolute
  width 100px
  bottom 2.5px
  height 30px
  line-height 30px
  background url('~images/index/head/btn.png') no-repeat center
  background-size 100% 100%
  cursor pointer
  font-size 0.06rem
.eventBtn
  right 15px
.videoBtn
  right 130px
.qpBtn
  right 245px
.yjBtn
  right 360px
@media (min-height 1400px)
  .btn
    width 180px
    padding 4px 0
  .videoBtn
    right 220px
</style>
